export default "__VITE_ASSET__C51gf$_j__"